import { render } from "./eye_diagnosis.vue?vue&type=template&id=fcd71258&scoped=true"
import script from "./eye_diagnosis.vue?vue&type=script&lang=js"
export * from "./eye_diagnosis.vue?vue&type=script&lang=js"

import "./eye_diagnosis.vue?vue&type=style&index=0&id=fcd71258&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcd71258"]])

export default __exports__